var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8734 13.875H3.56324C3.46012 13.875 3.37574 13.9594 3.37574 14.0625V15.4688C3.37574 15.5719 3.46012 15.6562 3.56324 15.6562H17.7476L14.3656 19.9453C14.2695 20.0672 14.3562 20.25 14.5132 20.25H16.2125C16.3273 20.25 16.4351 20.1984 16.5078 20.107L20.464 15.0891C20.8507 14.5969 20.5015 13.875 19.8734 13.875ZM20.4382 8.34375H6.25387L9.6359 4.05469C9.73199 3.93281 9.64527 3.75 9.48824 3.75H7.78902C7.67418 3.75 7.56637 3.80156 7.49371 3.89297L3.53746 8.91094C3.15074 9.40313 3.49996 10.125 4.12574 10.125H20.4382C20.5414 10.125 20.6257 10.0406 20.6257 9.9375V8.53125C20.6257 8.42812 20.5414 8.34375 20.4382 8.34375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.14398cc32593f9fe46666508414c615e.svg";
export { ForwardRef as ReactComponent };